import { GET_INVENTORY_QUOTA, GET_INVENTORY_QUOTA_SUCCESS, GET_INVENTORY_QUOTA_ERROR, GET_INVENTORY_QUOTA_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetInventoryQuota = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVENTORY_QUOTA:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_INVENTORY_QUOTA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_INVENTORY_QUOTA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_INVENTORY_QUOTA_EMPTY:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetInventoryQuota;
